import {initialize} from 'ldclient-js';

let instance;
let readyPromise;

function buildClient(key, user, options) {
  instance = initialize(key, user, options);
  readyPromise = new Promise(resolve => instance.on('ready', () => resolve(instance)));
  instance.on('change', () => {});
}

export default function client(key, user, options) {
  if (!instance) {
    buildClient(key || 'placeholder', user, options || {});
  } else if (user) {
    instance.identify(user);
  }
  return instance;
}

export function reset() {
  instance = null;
  readyPromise = null;
}

export function promise() {
  return readyPromise || Promise.reject('Launch Darkly not initialised');
}
